import { useParams } from 'react-router-dom'

import AccessDenied from '@/components/ui/template/AccessDenied'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { selectConsultationById } from '@/redux/reducers/consultation.reducer'
import { patientApi } from '@/core/api/patient'

export type ProtectedConsultationPageProps = {
  children: React.ReactElement
}

export default function ProtectedConsultationPage(props: ProtectedConsultationPageProps) {
  const { children } = props
  const { consultationId } = useParams()

  const authUser = useAppSelector(selectAuthUser)
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))

  const isDeniedByBasicRules =
    consultation &&
    Array.isArray(consultation.participants) &&
    consultation.participants.every((participant) => participant.email !== authUser?.email) &&
    // backward compatibility for consultations that didn't have participants
    authUser?._id !== consultation.pds?._id &&
    authUser?._id !== consultation.medecin?._id &&
    authUser?._id !== consultation.patient._id

  const {
    data: patient,
    isError: isPatientError,
    isLoading: isPatientLoading,
  } = patientApi.useGetPatientQuery(consultation?.patient?._id ?? '', {
    skip: !consultation?.patient?._id || !isDeniedByBasicRules,
  })

  if (!authUser) return null

  if (isDeniedByBasicRules) {
    if (isPatientLoading) return null
    if (patient && !isPatientError) return children
    return <AccessDenied />
  }

  return children
}
